import React, { useState } from 'react';
import classnames from 'classnames';
import { useTransition, animated } from 'react-spring';
import { Link } from 'react-router-dom';

import LoginForm from '../../auth/login/LoginFormContainer';
import RegisterForm from '../../auth/register/RegisterFormContainer';

import { LogoBlack } from '../../common/icons/Logos';

const tabs = ['Login', 'Register'];

const AuthPageMobile = () => {
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);

  const getChangeTabHandler = index => () => {
    setSelectedTabIndex(index);
  };

  const transitions = useTransition(selectedTabIndex, p => p, {
    from: { position: 'absolute', opacity: 0, transform: 'translate3d(0%, 0, 0)' },
    enter: { opacity: 1, transform: 'translate3d(0%, 0, 0)' },
    leave: { opacity: 0, transform: 'translate3d(0%, 0, 0)' },
  });
  return (
    <div className="m-container">
      <div className="is-flex justify-content-center py-20px">
        <Link to="/">
          <LogoBlack />
        </Link>
      </div>
      <div className="is-fullwidth is-flex justify-content-between">
        {tabs.map((tabName, tabIndex) => (
          <div
            key={tabName}
            className={classnames('login-tab', { active: tabIndex === selectedTabIndex })}
            style={{ width: '50%' }}
            onClick={getChangeTabHandler(tabIndex)}
          >
            {tabName}
          </div>
        ))}
      </div>
      <div
        className=" is-relative is-flex justify-content-center is-fullwidth"
        style={{ height: '350px', marginTop: '30px' }}
      >
        {transitions.map(({ item, props: transitionProps, key }) => {
          return (
            <animated.div key={key} style={{ ...transitionProps }} className="is-fullwidth">
              {item === 0 && (
                <>
                  <LoginForm />

                  <div className="auth-page-footer">
                    <Link to="/forgot-password" className="auth-page-link">
                      Forgot password?
                    </Link>
                  </div>
                </>
              )}
              {item === 1 && <RegisterForm onSuccess={getChangeTabHandler(0)} />}
            </animated.div>
          );
        })}
      </div>
    </div>
  );
};

export default AuthPageMobile;
